'use strict';

var _ = require('lodash');

function Renderer (options) {
  this.map = options.map;
  this.transformer = options.transformer;
  this.Actions = options.Actions;
  this.Store = options.Store;
}

Renderer.create = function () {
  var inst = Object.create(this.prototype);
  var obj = this.apply(inst, arguments);
  return Object(obj) === obj ? obj : inst;
};

/**
 * Extend method to be used by child classes
 * @param  {Object|Array} protoProps Object or Array of Object to extend prototype with
 * @param  {Object} staticProps
 */
Renderer.extend = function (protoProps, staticProps) {
  var parent = this;
  var child;

  // Setup the child constructor
  if (protoProps && _.has(protoProps, 'constructor')) {
    child = protoProps.constructor;
  } else {
    child = function () {
      return parent.apply(this, arguments);
    };
  }

  _.extend(child, parent, staticProps);

  var Surrogate = function () {
    this.constructor = child;
  };

  Surrogate.prototype = parent.prototype;
  child.prototype = new Surrogate();

  if (protoProps) {
    if (_.isArray(protoProps)) {
      _.extend.apply(null, [child.prototype].concat(protoProps));
    } else {
      _.extend(child.prototype, protoProps);
    }
  }

  child.prototype.__super__ = parent.prototype;
  return child;
};

Renderer.prototype = {
  /**
   * Set transformer at runtime. Allows for hotswapping the transformer.
   */
  using: function (Transformer) {
    this.transformer = Transformer.create(this.Actions, this.Store);
    return this; // return `this` to allow for chaining
  }
};

module.exports = Renderer;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/render/Renderer.js